import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { useStore } from "../../context/StoreContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SUPPORT_LINKS = [
  { label: "Track order", to: "/track-order" },
  { label: "FAQ", to: "/faq" },
  { label: "Size guide", to: "/size-guide" },
  { label: "Shipping", to: "/shipping" },
  { label: "Returns", to: "/returns" },
  { label: "Contact us", to: "/contact" },
];

const Footer = () => {
  const { currency, setCurrency } = useStore();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submitNewsletter = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast("ENTER A VALID EMAIL");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast("WELCOME TO THE DAMAGE");
      setEmail("");
    } catch (err) {
      toast("SUBSCRIPTION FAILED, TRY AGAIN");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="footer" className="mt-20">
      {/* Section A: Join + Support */}
      <section className="bg-cream border-t border-ink/12 px-4 md:px-12 py-14 md:py-20">
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Join the community */}
          <div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase leading-none mb-5">
              Join the<br />Community
            </h2>
            <p className="font-body text-lg md:text-xl leading-relaxed text-ink/80 max-w-md mb-3">
              Get first-access to drops, behind-the-scenes from the workshop, and stories from the people we make this for.
            </p>
            <p className="font-body italic text-lg md:text-xl text-dc-red mb-6">
              No spam. No noise. Just damage.
            </p>
            <form
              onSubmit={submitNewsletter}
              className="flex max-w-[460px] rounded-full border border-ink/15 overflow-hidden"
              data-testid="newsletter-form"
            >
              <input
                type="email"
                placeholder="YOUR EMAIL"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent text-ink font-mono text-xs uppercase tracking-widest px-4 py-3 outline-none placeholder:text-ink/40"
                data-testid="newsletter-input"
              />
              <button
                type="submit"
                disabled={loading}
                className="bg-ink text-cream font-display uppercase tracking-wider px-6 py-3 text-sm md:text-base hover:bg-dc-red transition-colors disabled:opacity-50"
                data-testid="newsletter-submit"
              >
                {loading ? "..." : "JOIN"}
              </button>
            </form>
          </div>

          {/* Support */}
          <div className="bg-charcoal text-cream p-8 md:p-10">
            <h3 className="font-display text-3xl md:text-4xl uppercase tracking-wide mb-6">
              Support
            </h3>
            <ul className="space-y-3 font-mono text-xs uppercase tracking-widest">
              {SUPPORT_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="hover:text-dc-red transition-colors"
                    data-testid={`footer-${l.to.replace("/", "")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-[1440px] mx-auto mt-14 pt-6 border-t border-ink/10 flex flex-col sm:flex-row justify-between gap-4 font-mono text-[11px] uppercase tracking-widest text-ink/70">
          <span>&copy; DAMAGE CULTURE 2025 / MADE IN INDIA</span>
          <div className="flex items-center gap-3" data-testid="footer-currency-toggle">
            <button
              onClick={() => setCurrency("INR")}
              className={currency === "INR" ? "text-ink font-bold" : "hover:text-ink"}
            >
              INR &#8377;
            </button>
            <span className="opacity-40">|</span>
            <button
              onClick={() => setCurrency("USD")}
              className={currency === "USD" ? "text-ink font-bold" : "hover:text-ink"}
            >
              USD $
            </button>
          </div>
        </div>
      </section>

      {/* Section B: Red credit block */}
      <section className="bg-dc-red text-cream px-4 md:px-12 py-12 md:py-16">
        <div className="max-w-[1440px] mx-auto">
          <p className="font-mono text-[11px] uppercase tracking-widest opacity-80 mb-4">
            &copy;DC 2025 / DAMAGING THE CULTURE
          </p>
          <h3 className="font-display uppercase text-3xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
            WE DESIGN FOR THE OUTCASTS,<br />
            THE RIOTS, THE QUIET ONES.
          </h3>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
